import { BasvuruFlow, type ProductConfig } from "./BasvuruFlow";
import { digits, InfoNote, SelectField, TextField } from "./shared";

// WEB3 — Seyahat Sağlık teklif-talebi (lead-only, non-vehicle). Canonical [KAPI]:
// ülke/bölge + başlangıç/bitiş tarihi + kişi sayısı + her sigortalı doğum tarihi
// (başvuranın doğum tarihi kişisel adımda; çok kişili grupta danışman tamamlar).
// Teminat limiti/amaç [ADVISOR]. No vehicle block in the POST.

const BOLGE = [
  { value: "schengen", label: "Schengen" },
  { value: "avrupa", label: "Avrupa" },
  { value: "dunya", label: "Tüm Dünya" },
  { value: "yurtici", label: "Yurt içi" },
];

const config: ProductConfig = {
  product: "seyahat",
  intro: {
    eyebrow: "SEYAHAT SAĞLIK · TEKLİF TALEBİ",
    title: "Seyahat teklifi",
    text: "Yurt dışı ve yurt içi seyahatleriniz için sağlık güvencesi. Gideceğiniz bölge ve tarihlerle başlayın; yaş ve süre teminat kapsamınızı belirler.",
  },
  headerTitle: "Seyahat Sağlık",
  infoTitle: "Seyahatinizi tanıyalım",
  infoLead: "Gideceğiniz bölge, tarihler ve kişi sayısını girin.",
  renderInfo: (ctx) => (
    <>
      <SelectField
        id="bolge"
        label="Gidilecek ülke / bölge"
        value={ctx.fields.bolge ?? ""}
        onChange={ctx.setField("bolge")}
        options={BOLGE}
        error={ctx.errors.bolge}
      />
      <TextField
        id="baslangic"
        label="Başlangıç tarihi"
        type="date"
        value={ctx.fields.baslangic ?? ""}
        onChange={ctx.setField("baslangic")}
        error={ctx.errors.baslangic}
      />
      <TextField
        id="bitis"
        label="Bitiş tarihi"
        type="date"
        value={ctx.fields.bitis ?? ""}
        onChange={ctx.setField("bitis")}
        error={ctx.errors.bitis}
      />
      <TextField
        id="kisiSayisi"
        label="Kişi sayısı"
        inputMode="numeric"
        value={ctx.fields.kisiSayisi ?? ""}
        onChange={(v) => ctx.setField("kisiSayisi")(digits(v).slice(0, 2))}
        placeholder="Örn. 2"
        error={ctx.errors.kisiSayisi}
      />
      <InfoNote>
        Schengen vizesi için minimum 30.000 EUR teminat gerekir. Teminat limiti ve seyahat amacını
        danışmanınız netleştirir; grup poliçelerinde her sigortalının doğum tarihi sonradan alınır.
      </InfoNote>
    </>
  ),
  validateInfo: (ctx) => {
    const e: Record<string, string> = {};
    if (!(ctx.fields.bolge ?? "").trim()) e.bolge = "Bölge zorunlu.";
    if (!(ctx.fields.baslangic ?? "").trim()) e.baslangic = "Başlangıç tarihi zorunlu.";
    if (!(ctx.fields.bitis ?? "").trim()) e.bitis = "Bitiş tarihi zorunlu.";
    else if (
      (ctx.fields.baslangic ?? "") &&
      (ctx.fields.bitis ?? "") < (ctx.fields.baslangic ?? "")
    )
      e.bitis = "Bitiş tarihi başlangıçtan önce olamaz.";
    const kisi = digits(ctx.fields.kisiSayisi ?? "");
    if (!kisi || Number(kisi) < 1) e.kisiSayisi = "En az 1 kişi girin.";
    return e;
  },
  // SEYAHAT §4 trip block (webIntakeSchema.travel). travelers is a number (server
  // z.coerce.number()); dates are the native YYYY-MM-DD input values.
  buildTravel: (fields) => ({
    destination: (fields.bolge ?? "").trim() || undefined,
    startDate: (fields.baslangic ?? "").trim() || undefined,
    endDate: (fields.bitis ?? "").trim() || undefined,
    travelers: (fields.kisiSayisi ?? "").trim()
      ? Number(digits(fields.kisiSayisi ?? ""))
      : undefined,
  }),
  summary: (fields) => {
    const map: Record<string, string> = {
      schengen: "Schengen",
      avrupa: "Avrupa",
      dunya: "Tüm Dünya",
      yurtici: "Yurt içi",
    };
    return {
      label: `Seyahat · ${map[fields.bolge ?? ""] ?? "Seyahatiniz"}`,
      value: "Teklif hazırlanıyor",
    };
  },
};

export function SeyahatBasvuru() {
  return <BasvuruFlow config={config} />;
}
